module.exports = "<div class=\"timesheet\" #block></div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/injection/viewblocks/viewblocks.component.html
// module id = ./src/app/modules/injection/viewblocks/viewblocks.component.html
// module chunks = main